export const LANDLINE_VALID_FIRST_NUMBERS = [2, 3, 4, 5, 6];
